import React, { useMemo } from 'react';
import TransformSection from './common/transform-section';
import { registerInspector } from './inspector-registry';
import AppearanceSection from './shared/appearance-section';
import CornerRadiusSection from './shared/corner-radius-section';
import FillGradientSection from './shared/fill-gradient-section';
import SlotFilterSection from './shared/slot-filter-section';
import VisibleWhenSection from './shared/visible-when-section';
import { rectCornerStrategy } from './shared/corner-radii-strategies';
import { useCornerRadii } from './shared/use-corner-radii';
import { useFillGradient } from './shared/use-fill-gradient';
import type { ObjectInspectorProps } from './types';

const RectInspector: React.FC<ObjectInspectorProps> = ({ objects, editor }) => {
  const cornerStrategy = useMemo(() => rectCornerStrategy(editor), [editor]);
  const radii = useCornerRadii(objects, editor, cornerStrategy);
  const gradient = useFillGradient(objects, editor);

  return (
    <>
      <TransformSection objects={objects} editor={editor} />
      <AppearanceSection objects={objects} editor={editor} gradient={gradient} />
      <CornerRadiusSection control={radii} />
      <FillGradientSection control={gradient} />
      <SlotFilterSection objects={objects} editor={editor} />
      <VisibleWhenSection objects={objects} editor={editor} />
    </>
  );
};

export default RectInspector;

registerInspector('rect', RectInspector);
